export default __webpack_public_path__ + "static/media/icon-no-comments.5617cec7.svg";